import { lazy } from "react";

export const SurveyScalesPage = lazy(() => import("./survey-scales"));
export { SURVEY_SCALES_PATH } from "./survey-scales-path";
